// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"226":"48de2d50","328":"b0335ba8","489":"772f5853","848":"d5a64508"}[chunkId] + ".chunk.js");